import { BodyRequestCandidates } from "../../v1/models/pages_coid_jobs_jid";
import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";
import { SR } from "../schemas/schemas/schema-reponses.js";

export class CandidatesAPI {
	async put_pages_coid_jobs_jid_u(
		pgid: PGSchema.pages["id"],
		jid: string | PGSchema.jobs["job_id"],
		body: { uids: PGSchema.users["id"][]; phase: number; pipeline: { id: number; name: string }[]; title: string; thumb_pp: PGSchema.pages["thumb_pp"]; token: string },
		module_ = "jobs"
	) {
		const r = await xhttp<{}>(`/pages/${pgid}/${module_}/${jid}/u`, "PUT", body);
		return r;
	}

	getCandidates(pgid: PGSchema.pages["id"], jid: PGSchema.jobs["job_id"], js: BodyRequestCandidates, module_ = "jobs", token: string) {
		return xhttp<SR.apiv2.pages.candidates.get_pages_coid_jobs_jid>(`/pages/${pgid}/${module_}/${jid}/users`, "SEARCH", js, { headers: { "app-token": token } });
	}

	getCandidate(pgid: PGSchema.pages["id"], module_ = "jobs", jid: PGSchema.jobs["job_id"], uid: PGSchema.users["id"], token: string) {
		return xget<{ data: PGSchema.users; pages?: PGSchema.pages[]; user_jobs: PGSchema.users_jobs[] }>(`/pages/${pgid}/${module_}/${jid}/users/${uid}`, { token });
	}

	moveCandidate(pgid: PGSchema.pages["id"], data: { uid: PGSchema.users["id"]; from: PGSchema.users_jobs["job_id"]; to: PGSchema.users_jobs["job_id"] }, token: string) {
		return xhttp(`/pages/${pgid}/move_candidate`, "POST", data, { headers: { "app-token": token } });
	}
}
